import { put, select } from 'redux-saga/effects';

import { selectors as configSelectors } from '@elab/core/store/config';
import { addressPopup } from '@elab/core/utils/constants';
import { getActions as getDisplayOneByOneActions } from '@elab/components/connected/DisplayOneByOne/redux';

const availableOnDialogs = [
    ...Object.values(addressPopup),
    'add-delivery-address',
    'add-billing-address',
];

export function* handleCloseDialog(storeName, { payload }) {
    const closedDialogName = (payload && payload.name) || payload;
    const displayOneByOneActions = getDisplayOneByOneActions(storeName);
    const { hiddenFields } = yield select(configSelectors.getAddressFormConfig);
    if (!hiddenFields || availableOnDialogs.every(dialogName => closedDialogName !== dialogName)) {
        return;
    }
    yield put(displayOneByOneActions.resetItemsToShow());
}
